import { useState } from 'react';
import { ErroreRisposta, type Profilo, api } from '../api/client.ts';
import { MarchioT2D } from '../app/MarchioT2D.tsx';
import stili from './Accesso.module.css';

/**
 * Schermata di accesso.
 *
 * Un modulo solo, nessuna registrazione: gli account li crea
 * l'Amministratore, perche' l'anagrafica arriva dal gestionale e non da chi
 * si iscrive.
 */
export function Accesso({ onEntrato }: { onEntrato: (profilo: Profilo) => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState<string | null>(null);
  const [inCorso, setInCorso] = useState(false);

  async function invia(evento: React.FormEvent) {
    evento.preventDefault();
    setErrore(null);
    setInCorso(true);
    try {
      onEntrato(await api.accedi(username, password));
    } catch (e) {
      setErrore(
        e instanceof ErroreRisposta ? e.message : 'Impossibile contattare il server.',
      );
    } finally {
      setInCorso(false);
    }
  }

  return (
    <div className={stili.pagina}>
      <form className={stili.riquadro} onSubmit={invia}>
        <div className={stili.intestazione}>
          <MarchioT2D className={stili.logo} />
          <h1 className={stili.titolo}>Gestionale Assenze</h1>
        </div>
        <p className={stili.sottotitolo}>Accedi con le credenziali aziendali</p>

        <label className={stili.campo}>
          <span className={stili.etichetta}>Nome utente</span>
          <input
            className={stili.input}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />
        </label>

        <label className={stili.campo}>
          <span className={stili.etichetta}>Password</span>
          <input
            className={stili.input}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>

        {errore && <p className={stili.errore}>{errore}</p>}

        <button
          type="submit"
          className={stili.pulsante}
          disabled={inCorso || username === '' || password === ''}
        >
          {inCorso ? 'Accesso in corso…' : 'Entra'}
        </button>
        <a className={stili.collegamento} href="/recupera-password">
          Password dimenticata?
        </a>
      </form>
    </div>
  );
}
